import React from 'react'
import TooltipPopover from "@/components/shared/others/TooltipPopover"
import Typography from '@mui/material/Typography'

const HelpPopover = () => (
  <TooltipPopover>
    <Typography variant='h5'>Aqui você cadastra as pessoas da sua equipe que irão gerenciar e executar os serviços.</Typography>
    <br />
    <Typography>Elas podem ser vinculadas nas atividades criadas e clientes cadastrados. Cada usuário tem um tipo de acesso:</Typography>
    <br />
    <ul>
    <li><Typography><strong>Administrador: </strong>
    Acessa todas as opções do nosso software e aplicativo.</Typography></li>
    <li><Typography><strong>Diretor/Gerente: </strong>
    Acessa todas as opções do nosso software, menos cadastrar e remover usuários da Equipe.</Typography></li>
    <li><Typography><strong>Supervisor: </strong>
    Cria atividades e também preenche e visualiza todos os dados das atividades em que é responsável. Não tem acesso aos dados de outras atividades, alteração de formulários e algumas outras configurações.</Typography></li>
    <li><Typography><strong>Membro: </strong>
    Preenche e visualiza apenas os dados das atividades em que é responsável. Por padrão, também cria atividades, mas essa opção pode ser desabilitada pelo administrador.</Typography></li>
    <li><Typography><strong>Cliente: </strong>
    Visualiza as informações das atividades a que está vinculado. Esse perfil é utilizado para que o cliente acompanhe em tempo real o trabalho que está em andamento.</Typography></li></ul>
  </TooltipPopover>
)
export default HelpPopover
